

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.B_MppsTH.js","_app/immutable/chunks/disclose-version.C-B3b31r.js","_app/immutable/chunks/runtime.CwyCtKqw.js","_app/immutable/chunks/legacy.CiTDcgnC.js","_app/immutable/chunks/slot.Cjv-8_r3.js"];
export const stylesheets = ["_app/immutable/assets/0.BmYsreo_.css"];
export const fonts = ["_app/immutable/assets/roboto-regular.CjbfJjO0.woff2","_app/immutable/assets/roboto-medium.DRylU_ql.woff2","_app/immutable/assets/sofia-pro-regular.DIjwlQ4Y.woff2","_app/immutable/assets/sofia-pro-bold.NChdeqeg.woff2","_app/immutable/assets/sofia-pro-black.DVGQlFTu.otf"];
